export const MEMBERSHIP_MINIMUM_CENTS_FEE_PERSONAL = 2400;
export const MEMBERSHIP_MINIMUM_CENTS_FEE_COMPANY = 10000;
export const MEMBERSHIP_MAXIMUM_CENTS = 100_000_00;
